<template>
  <div>
    <back-btn />
    <b-card
      no-body
      class="mb-0"
    >
      <b-table
        ref="refPhysicianListTable"
        class="position-relative"
        :items="fetchPhysicians"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <template
          #cell(physician.name)="{ item }"
        >
          <div class="font-weight-bold institution-name">
            {{ item.physician.name }}
          </div>
          <div>{{ formatCpf(item.physician.cpf, true) }}</div>
        </template>
        <template
          #cell(created_at)="{ item }"
        >
          <div class="font-weight-bold institution-name">
            {{ item.released_name }}
          </div>
          <div>{{ formatDateTimeDDMMYYHHMM(new Date(item.created_at)) }}</div>
        </template>
        <template #cell(file)="{ item }">
          <div v-if="item.uploaded_file">
            <b-link
              class="text-underline"
              :title="item.uploaded_file.file_name"
              @click="openFile(item.uploaded_file)"
            >
              <feather-icon
                icon="DownloadIcon"
                size="16"
              />
            </b-link>
          </div>
          <div v-else>
            -
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo {{ totalPhysicians }} entradas</span>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BLink,
} from 'bootstrap-vue'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import {
  formatCpf, formatDateTimeDDMMYYHHMM, maskCnpj, openLink, truncateString,
} from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import BackBtn from '@core/components/navigation/BackBtn.vue'
import usePhysicianList from './usePhysicianList'
import physicianStoreModule from '../../reportStoreModule'

export default {
  components: {
    BLink,
    BackBtn,
    BCard,
    BRow,
    BCol,
    BTable,
  },
  directives: {
    Ripple,
  },
  methods: { formatCpf, formatDateTimeDDMMYYHHMM, truncateString },
  setup() {
    const PHYSICIAN_APP_STORE_MODULE_NAME = 'app-physician'

    // Register module
    if (!store.hasModule(PHYSICIAN_APP_STORE_MODULE_NAME)) store.registerModule(PHYSICIAN_APP_STORE_MODULE_NAME, physicianStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PHYSICIAN_APP_STORE_MODULE_NAME)) store.unregisterModule(PHYSICIAN_APP_STORE_MODULE_NAME)
    })

    const paymentStatusOptions = []

    const isValid = ref(true)
    const institutionOptions = ref(null)

    const fetchInstitutions = () => {
      store.dispatch('app-physician/fetchInstitutions', { perPage: 99999999 })
        .then(response => {
          institutionOptions.value = response.data.data.map(inst => ({
            value: inst.id,
            label: `${truncateString(inst.name, 18)} | ${maskCnpj(inst.cnpj)}`,
          }))
        })
    }
    fetchInstitutions()

    function openFile(item) {
      store.dispatch('app-physician/getPhysicianMotiveFile', { id: item.id })
        .then(response => {
          openLink(response.data.data.url)
        }).catch(() => {
        //
        })
    }

    const {
      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalPhysicians,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPhysicianListTable,
      refetchData,
      downloadReport,
      scheduleRestrictionFilter,
      beginDate,
      endDate,
      institutionId,
    } = usePhysicianList()

    return {
      isValid,
      downloadReport,
      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalPhysicians,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPhysicianListTable,
      refetchData,
      beginDate,
      endDate,

      // Filter
      avatarText,
      openFile,

      // UI

      paymentStatusOptions,

      // Extra Filters
      scheduleRestrictionFilter,
      institutionId,
      institutionOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.physician-class {
  width: 15px;
  height: 15px;
  border-spacing: 0!important;
  margin-top: 2px;
}
.physician-class {
  width: 15px;
  height: 15px;
  border-spacing: 0!important;
  margin-top: 2px;
  &:before {
    content: '';
    transform: translateY(3px);
    width: 15px;
    height: 15px;
    display: inline-block;
    border-radius: 15px;
    background-position: center center;
    background-repeat: no-repeat;
  }
  &-red {
    &:before {
      background-color: #f08182;
    }
  }
  &-yellow {
    &:before {
      background-color: #ffb976;
    }
  }
  &-green {
    &:before {
      background-color: #48da89;
    }
  }
}
@media (max-width: 1400px) {
  .v-select {
    font-size: 12px;
  }
}
.v-select {
  .physician-class {
    &:before {
      transform: translateY(2px) translateX(-4px);
    }
  }
}
.vs__selected {
  .physician-class {
    &:before {
      transform: translateY(-4px) translateX(-2px);
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
